import { api } from "../api";

/**
 * userFindAllDepartmentsListResponse - Function that finds on database all departments allowed per user as select list response  
 * /users/{id}/{secretaryId}/departments/list  
 * method GET 
 * @async-function
 */
const userFindAllDepartmentsListResponse = async (token: string, id: number, secretaryId: Number) => {
    const response = await api.get(
        `/users/${id}/${secretaryId}/departments/list`, {
        headers: {
            'Authorization': `Bearer ${token}`
        },
    }
    );
    return response;
};

export default userFindAllDepartmentsListResponse;